// Replacement for https://lodash.com/docs/4.17.15#last
export const last = <T>(array: T[]) => {
    return array[array.length - 1];
};
// Replacement for https://lodash.com/docs/4.17.15#last
export const last = <T>(array: T[]) => {
    return array[array.length - 1];
};
